/**
 * @class Oskari.nba.bundle.nba-registry-editor.view.SideRegistryEditor
 */
import jstsOL3Parser from 'jsts/org/locationtech/jts/io/OL3Parser';
import * as olGeom from 'ol/geom';
import LinearRing from 'ol/geom/LinearRing';
import GeometryCollection from 'ol/geom/GeometryCollection';
import Point from 'jsts/org/locationtech/jts/geom/Point';

const olParser = new jstsOL3Parser();
olParser.inject(olGeom.Point, olGeom.LineString, LinearRing, olGeom.Polygon, olGeom.MultiPoint, olGeom.MultiLineString, olGeom.MultiPolygon, GeometryCollection);

Oskari.clazz.define('Oskari.nba.bundle.nba-registry-editor.view.SideRegistryEditor',
    /**
     * @static @method create called automatically on construction
     *
     * @param {Oskari.nba.bundle.nba-registry-editor.RegistryEditorBundleInstance} instance
     * Reference to component that created this view
     * @param {Object} loc
     * Localization data in JSON format
     * @param {Object} data
     * Item data from search ui
     */
    function (instance, localization, data) {
        var me = this;
        me.sandbox = instance.sandbox;
        me.instance = instance;
        me.geoJson = null;
        me.loc = localization;
        me.data = data; //item data from search ui
        me.itemData = null;  //full item data from registry
        me.templates = {
                'drawHelper': jQuery('<div class="drawHelper"><div class="infoText"></div></div>'),
                //common templates
                'coordinatePopupContent': jQuery('<div class="nba-registry-editor-coordinates-popup-content"><div class="description"></div>' +
                    '<div class="margintop"><div class="floatleft"><select class="srs-select"></select></div><div class="clear"></div></div>' +
                    '<div class="margintop"><div class="floatleft"><input type="text" class="lat-input" placeholder="' + me.loc.coordinateLat + '"></input></div><div class="clear"></div></div>' +
                    '<div class="margintop"><div class="floatleft"><input type="text" class="lon-input" placeholder="' + me.loc.coordinateLon + '"></input></div><div class="clear"></div></div>' +
                    '</div>'),
                'noItemsFound': jQuery('<div class="noItemsFound">' + me.loc.noItemsFound + '</div>')
        };
        me.template = jQuery(
            '<div class="content-editor">' +
            '  <div class="header">' +
            '    <div class="icon-close">' +
            '    </div>' +
            '    <h3></h3>' +
            '  </div>' +
            '  <div class="content-registry-item">' +
            '  </div>' +
            '</div>');
        me._dialog = null;
        me.editFeature = null; //current item in editing, can be main item, sub item or area item
        me.progressSpinner = Oskari.clazz.create('Oskari.userinterface.component.ProgressSpinner');
        me._coordsConvertionEnabled = false;
        me.registerView = null; //current register view class
    }, {
        __name: 'RegistryEditor',
        /**
         * @method getName
         * @return {String} the name for the component
         */
        getName: function () {
            return this.__name;
        },

        /**
	    * @method getSandbox
	    * @return {Oskari.mapframework.sandbox.Sandbox}
	    */
        getSandbox: function () {
            return this.sandbox;
        },

        showMessage: function(title, content, buttons, isModal) {
            var me = this;
            this.closeDialog();
            this._dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
            if(typeof buttons === 'undefined') {
                var okBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.OkButton');

                okBtn.setHandler(function () {
                    me._dialog.close(true);
                    me._dialog = null;
                });

                buttons = [okBtn];
            }
            this._dialog.show(title, content, buttons);
            if (isModal) {
                this._dialog.makeModal();
            }
            return this._dialog;
        },

        /**
         * Closes the message dialog if one is open
         */
        closeDialog : function() {
            if(this._dialog) {
                this._dialog.close(true);
                this._dialog = null;
            }
        },

        /**
         * @method startNewDrawing
         * Sends a StartDrawRequest with given params. Changes the panel controls to match the application state (new/edit)
         * @param config params for StartDrawRequest
         */
        sendDrawRequest: function (config, id) {
            var me = this,
                conf = jQuery.extend(true, {}, config);
            if(conf.drawMode === "area" ) {
                if(typeof conf.geometry !== 'undefined') {
                   var geojsonForEdit = {
                        "type": "FeatureCollection",
                        "features": [
                            {
                                "type": "Feature",
                                "id": id,
                                "geometry": conf.geometry
                            }]
                    };
                    me.getSandbox().postRequestByName('DrawTools.StartDrawingRequest',['newDrawing', 'Polygon',  {
                        modifyControl: true,
                        geojson: geojsonForEdit
                    }]);
                }
                else {
                    me.getSandbox().postRequestByName('DrawTools.StartDrawingRequest',['newDrawing', 'Polygon']);
                }
            }
            else if(conf.drawMode === "point") {
                me.getSandbox().postRequestByName('DrawTools.StartDrawingRequest',['newDrawing', 'Point']);
            }
            me.instance.enableGfi(false);
            me._showDrawHelper(conf.drawMode, id, typeof conf.geometry !== 'undefined');
        },

        /**
         * @method sendStopDrawRequest
         * Sends a StopDrawingRequest.
         * Changes the panel controls to match the application state (new/edit) if propagateEvent != true
         * @param {Boolean} isCancel boolean param for StopDrawingRequest, true == canceled, false = finish drawing (dblclick)
         */
        sendStopDrawRequest: function (isCancel) {
            var me = this;
            if (isCancel) {
                // we wish to clear the drawing without sending further events
                me.getSandbox().postRequestByName('DrawTools.StopDrawingRequest', ['newDrawing', true]);
            } else {
                // pressed finished drawing, act like dblclick
                me.getSandbox().postRequestByName('DrawTools.StopDrawingRequest', ['newDrawing', true]);
            }
            me.instance.enableGfi(true);
        },

        /**
         * @method render
         * Renders view to given DOM element
         * @param {jQuery} container reference to DOM element this component will be
         * rendered to
         */
        render: function (container) {
            var me = this,
                content = me.template.clone(),
                itemDetails;

            me.mainPanel = content;
            container.append(content);
            content.find('div.header h3').append(me.loc.title);
            me._refreshData(me.data.id);
            content.find(".icon-close").on('click', function(){
                me.instance.setEditorMode(false);
            });
        },

        _refreshData: function(id) {
            var me = this,
                content = me.mainPanel,
                postData = null,
                itemDetails;

            content.find(".content-registry-item").empty();
            me.progressSpinner.insertTo(content.find(".content-registry-item"));
            me.progressSpinner.start();

            me._setRegisterView();

            if (me.registerView != null) {
                jQuery.ajax({
                    url: me.instance.sandbox.getAjaxUrl(),
                    data: { 'action_route': 'GetRegistryItems', 'registerName': me.registerView.getRegisterName(), 'id': me.data.id },
                    type: 'GET',
                    success: function (data, textStatus, jqXHR) {
                        me.progressSpinner.stop();
                        content.find(".content-registry-item").empty();
                        me.itemData = data;
                        itemDetails = me.registerView.render(data);
                        content.find(".content-registry-item").append(itemDetails);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        me.showMessage(me.loc.error, me.loc.searchError);
                    }
                });
            }
        },

        _setRegisterView: function () {
            var me = this;
            me.registerView = null;
            if (me.data.registryIdentifier === 'ancientMonument') {
                me.registerView = Oskari.clazz.create('Oskari.nba.bundle.nba-registry-editor.view.AncientMonumentView', me, me.loc);
            } else if (me.data.registryIdentifier === 'ancientMaintenance') {
                me.registerView = Oskari.clazz.create('Oskari.nba.bundle.nba-registry-editor.view.AncientMonumentMaintenanceView', me, me.loc);
            } else if (me.data.registryIdentifier === 'buildingHeritage') {
                me.registerView = Oskari.clazz.create('Oskari.nba.bundle.nba-registry-editor.view.BuildingHeritageView', me, me.loc);
            } else if (me.data.registryIdentifier === 'rky2000') {
                me.registerView = Oskari.clazz.create('Oskari.nba.bundle.nba-registry-editor.view.RKY2000View', me, me.loc);
            } else if (me.data.registryIdentifier === 'project') {
                me.registerView = Oskari.clazz.create('Oskari.nba.bundle.nba-registry-editor.view.ProjectView', me, me.loc);
            }//TODO missing WorldHeritage, Resource
        },

        formatData: function(label, data) {
            var ret = '<div class="registryItemAttrLabel">' + label + "</div>";
            if(typeof data !== 'undefined' && data !== null) {
                if(data.startsWith && data.startsWith("http")) {
                    ret += '<a href="' + data + '">' + this.loc.link + '</a>';
                } else {
                    ret += data;
                }
            }
            return ret;
        },

        /**
         * @method getEditTools
         * Add buttons for editing registry item or subitem.
         *
         * @param {Object} conf - configuration object for tools. Available properties:
         *      - point (true/false)
         *      - area (true/false)
         *      - line (true/false)
         *      - feature (Object)
         *      - type ('main'/'sub')
         *      - deleteOption (true/false)
         *      - id
         */
        getEditTools: function(conf) {
            var me = this,
                geometryType,
                container = jQuery('<div class=toolrow></div>'),
                locBtns = me.instance.getLocalization('buttons'),
                /*pointButton = jQuery("<div />").addClass('add-point tool'),
                pointXYButton = jQuery("<div />").addClass('add-point-xy tool'),
                lineButton = jQuery("<div />").addClass('add-line tool'),
                areaButton = jQuery("<div />").addClass('add-area tool'),
                copyButton = jQuery("<div />").addClass('tool-feature-selection tool');*/
                pointButton = jQuery('<button type="button">' + locBtns.addNewPoint + '</button>').addClass('registryItemActionButton'),
                pointXYButton = jQuery('<button type="button">' + locBtns.createWithXY + '</button>').addClass('registryItemActionButton'),
                lineButton = jQuery('<button type="button">' + locBtns.addNewLine + '</button>').addClass('registryItemActionButton'),
                areaButton = jQuery('<button type="button">' + locBtns.addNewArea + '</button>').addClass('registryItemActionButton'),
                copyButton = jQuery('<button type="button">' + locBtns.copyGeometry + '</button>').addClass('registryItemActionButton'),
                deletePointButton = jQuery('<button type="button">' + locBtns.deletePoint + '</button>').addClass('registryItemActionButton'),
                deleteAreaButton = jQuery('<button type="button">' + locBtns.deleteArea + '</button>').addClass('registryItemActionButton'),
                deleteLineButton = jQuery('<button type="button">' + locBtns.deleteLine + '</button>').addClass('registryItemActionButton'),
                deleteFromMultiButton = jQuery('<button type="button">' + locBtns.deleteMulti + '</button>').addClass('registryItemActionButton');

            if (typeof conf.point !== 'undefined' && conf.point) {
                pointButton.on('click', function() {
                    var geometry = undefined;
                    geometryType = 'point';
                    if(conf.feature.geometry != null) {;
                        geometry = conf.feature.geometry;
                    } else if (conf.feature.pointGeometry != null) {
                        geometry = conf.feature.pointGeometry;
                    }

                    me.sendDrawRequest({
                        drawMode: geometryType,
                        geometry: geometry
                    }, this.id);
                    me.editFeature = conf.feature;
                    if(typeof me.editFeature._type === 'undefined') {
                        me.editFeature._type = conf.type;
                    }
                    me.editFeature._geometryType = geometryType;
                });
                pointButton.attr('id', 'point-' + conf.type + "-" + conf.id);
                if (conf.feature.geometry != null || conf.feature.pointGeometry != null) {
                    pointButton.html(locBtns.editPoint);
                }
                container.append(pointButton);

                pointXYButton.on('click', function () {
                    geometryType = 'point';

                    var pointxyButtonId = this.id,
                        cont = function() {
                            me.editFeature = conf.feature;
                            me._showCoordinatesPopUp(pointxyButtonId);
                            me._dialog.moveTo('div#' + this.id, 'top');
                            if(typeof me.editFeature._type === 'undefined') {
                                me.editFeature._type = conf.type;
                            }
                            me.editFeature._geometryType = geometryType;
                        };

                    if ((typeof conf.feature.geometry === 'undefined' || conf.feature.geometry === null) && (typeof conf.feature.pointGeometry === 'undefined' || conf.feature.pointGeometry === null)) {
                        cont();
                    } else {
                        var title = me.loc.warning,
                            content = me.loc.featureHasGeometry,
                            continueButton = Oskari.clazz.create('Oskari.userinterface.component.Button'),
                            cancelButton = Oskari.clazz.create('Oskari.userinterface.component.buttons.CancelButton'),
                            buttons = [cancelButton, continueButton];

                        cancelButton.setHandler(function() {
                            me._dialog.close(true);
                            me._dialog = null;
                        });
                        continueButton.setTitle(me.instance.getLocalization('buttons')["continue"]);
                        continueButton.addClass('primary');
                        continueButton.setHandler(function() {
                            me._dialog.close(true);
                            me._dialog = null;
                            cont();
                        });
                        me.showMessage(title, content, buttons);
                    }
                });
                pointXYButton.attr('id', 'pointxy-' + conf.type + "-" + conf.id);
                container.append(pointXYButton);

                if (conf.deleteOption && (conf.feature.geometry != null || conf.feature.pointGeometry)) {
                    deletePointButton.on('click', function() {
                        if (conf.type == 'main') {
                            me._deleteGeometry(conf.feature, 'point');
                        } else {
                            me._deleteGeometry(conf.feature);
                        }
                    });
                    deletePointButton.attr('id', 'deletePoint-' + conf.type + "-" + conf.id);
                    container.append(deletePointButton);
                }
            }

            if (typeof conf.line !== 'undefined' && conf.line) {
                lineButton.on('click', function() {
                    geometryType = 'line';
                    var geometry = undefined;
                    if(typeof conf.feature.geometry !== 'undefined') {
                        geometry = conf.feature.geometry;
                    }
                    me.sendDrawRequest({
                        drawMode: geometryType,
                        geometry: geometry
                    }, this.id);
                    me.editFeature = conf.feature;
                    if(typeof me.editFeature._type === 'undefined') {
                        me.editFeature._type = conf.type;
                    }
                    me.editFeature._geometryType = geometryType;
                });
                lineButton.attr('id', 'line-' + conf.type + "-" + conf.id);
                if (conf.feature.geometry != null) {
                    lineButton.html(locBtns.editLine);
                }
                container.append(lineButton);

                if (conf.deleteOption && conf.feature.geometry != null) {
                    deleteLineButton.on('click', function() {
                        me._deleteGeometry(conf.feature);
                    });
                    deleteLineButton.attr('id', 'deleteLine-' + conf.type + "-" + conf.id);
                    container.append(deleteLineButton);
                }
            }

            if (typeof conf.area !== 'undefined' && conf.area) {
                areaButton.on('click', function() {
                    geometryType = 'area';
                    var geometry = undefined;
                    if(conf.feature.geometry != null) {
                        geometry = conf.feature.geometry;
                    } else if (conf.feature.areaGeometry != null) {
                        geometry = conf.feature.areaGeometry;
                    }
                    me.sendDrawRequest({
                        drawMode: geometryType,
                        geometry: geometry
                    }, this.id);
                    me.editFeature = conf.feature;
                    if(typeof me.editFeature._type === 'undefined') {
                        me.editFeature._type = conf.type;
                    }
                    me.editFeature._geometryType = geometryType;
                });
                areaButton.attr('id', 'area-' + conf.type + "-" + conf.id);
                if (conf.feature.geometry != null || conf.feature.areaGeometry != null) {
                    areaButton.html(locBtns.editArea);
                }
                container.append(areaButton);

                if (conf.deleteOption && (conf.feature.geometry != null || conf.feature.areaGeometry)) {
                    deleteAreaButton.on('click', function() {
                        if (conf.type == 'main') {
                            me._deleteGeometry(conf.feature, 'area');
                        } else {
                            me._deleteGeometry(conf.feature);
                        }
                    });
                    deleteAreaButton.attr('id', 'deleteArea-' + conf.type + "-" + conf.id);
                    container.append(deleteAreaButton);
                }

                if (conf.feature.geometry != null && conf.feature.geometry.type === "MultiPolygon" && conf.feature.geometry.coordinates.length > 1) {
                    deleteFromMultiButton.on('click', function() {
                        me.editFeature = conf.feature;
                        if(typeof me.editFeature._type === 'undefined') {
                            me.editFeature._type = conf.type;
                        }
                        me.editFeature._geometryType = geometryType;
                        me._deleteFromMulti(conf.feature, 'area');
                    });
                    deleteFromMultiButton.attr('id', 'deleteFromMulti-' + conf.type + "-" + conf.id);
                    container.append(deleteFromMultiButton);
                }
            }

            copyButton.on('click', function () {
                var currentCopyButton = this;

                var onFinishSelectionCallback = function () {
                    var builder = me.sandbox.getEventBuilder('WFSFeaturesSelectedEvent'),
                        wfsFeaturesSelectedEvent,
                        selectedGeometriesCount = 0,
                        selectedFeature = null,
                        selectedFeatureGeoJson,
                        selectedFeatureAttributes,
                        selectedFeatureFields,
                        selectedLayer,
                        defaults,
                        layerFeatures,
                        layer,
                        feature;


                    var vectorSelectionService = Oskari.getSandbox().getService('Oskari.mapframework.service.VectorFeatureSelectionService');
                    var selectionLayers = vectorSelectionService.getLayerIdsWithSelections();

                    if (selectionLayers.length > 0) {
                        selectionLayers.forEach(layerId => {
                            var selectedFeatures = vectorSelectionService.getSelectedFeatureIdsByLayer(layerId);
                            layerFeatures = me.sandbox.findRegisteredModuleInstance('MainMapModule').getLayerPlugins('wfs').getOLMapLayers(me.sandbox.findMapLayerFromAllAvailable(layerId))[0].getSource().getFeatures();
                            layer = me.sandbox.findMapLayerFromAllAvailable(layerId);
                            feature = layerFeatures.filter(f => {
                                return selectedFeatures.includes(f.id_);
                            })[0];
                        });

                        selectedFeature = feature;
                        var vectorFeatureService = me.sandbox.getService('Oskari.mapframework.service.VectorFeatureService');
                        var geoJson = vectorFeatureService._getGeojson(feature);
                        var geoJsonForCopy;
                        if (geoJson !== null || geoJson !== 'undefined') {
                            selectedGeometriesCount++;
                            geoJsonForCopy = me._getGeometryInfoForCopy(conf, geoJson.features[0].geometry);
                        }
                        if (geoJsonForCopy != null) {
                            me.editFeature._geometryType = geoJsonForCopy.geometryType;
                            selectedFeatureGeoJson = geoJsonForCopy.featureGeoJson;
                            selectedFeatureAttributes = me._getLayerAttributes(layer, feature);
                            selectedFeatureFields = feature && feature.values_ ? Object.keys(feature.values_) : [];

                            selectedLayer = layer;
                        }
                    }

                    if (selectedGeometriesCount > 0) {
                        if (selectedFeature == null) {
                            //none of selected geometries is valid - show error
                            me.showMessage(me.loc.error, me.loc.wrongGeometryError);
                        } else if (selectedGeometriesCount == 1) {
                            //one selected geometry (valid) - go to next step
                            vectorSelectionService.removeSelection();
                            me._showParameterUpdateDialog(currentCopyButton.id, selectedFeatureGeoJson, selectedFeatureAttributes, selectedFeature, selectedFeatureFields, defaults);
                        } else {
                            //more geometries are selected (at least one is valid) - highlight valid geometry, show warning and go to next step
                            wfsFeaturesSelectedEvent = builder([selectedFeature[0]], selectedLayer, false);
                            me.sandbox.notifyAll(wfsFeaturesSelectedEvent);

                            var copyOkBtn = Oskari.clazz.create('Oskari.userinterface.component.Button');
                            copyOkBtn.setTitle(me.instance.getLocalization('buttons').ok);
                            copyOkBtn.addClass('primary');
                            copyOkBtn.setHandler(function () {
                                me._dialog.close(true);
                                me._dialog = null;
                                me._showParameterUpdateDialog(currentCopyButton.id, selectedFeatureGeoJson, selectedFeatureAttributes, selectedFeature, selectedFeatureFields, defaults);
                                vectorSelectionService.removeSelection();
                            });

                            var copyCancelBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.CancelButton');
                            copyCancelBtn.setHandler(function () {
                                me._dialog.close(true);
                                me._dialog = null;
                                vectorSelectionService.removeSelection();
                            });
                            me.showMessage(me.loc.warning, me.loc.selectWarning, [copyOkBtn, copyCancelBtn]);
                        }
                    }
                };

                var cont = function() {
                    var popupHandler = Oskari.clazz.create('Oskari.mapframework.bundle.featuredata2.PopupHandler', me);
                    popupHandler.showSelectionTools(onFinishSelectionCallback);
                    me.editFeature = conf.feature;
                    if (typeof me.editFeature._type === 'undefined') {
                        me.editFeature._type = conf.type;
                    }
                };

                if ((typeof conf.feature.geometry === 'undefined' || conf.feature.geometry === null) &&
                    (typeof conf.feature.pointGeometry === 'undefined' || conf.feature.pointGeometry === null) &&
                    (typeof conf.feature.areaGeometry === 'undefined' || conf.feature.areaGeometry === null)) {
                    cont();
                } else {
                    var title = me.loc.warning;
                    var content = me.loc.featureHasGeometry;
                    var continueButton = Oskari.clazz.create('Oskari.userinterface.component.Button');
                    var cancelButton = Oskari.clazz.create('Oskari.userinterface.component.buttons.CancelButton');
                    var buttons = [cancelButton, continueButton];

                    cancelButton.setHandler(function() {
                        me._dialog.close(true);
                        me._dialog = null;
                        cont();
                    });

                    continueButton.setTitle(me.instance.getLocalization('buttons')["continue"]);
                    continueButton.addClass('primary');
                    continueButton.setHandler(function() {
                        me._dialog.close(true);
                        me._dialog = null;
                        cont();
                    });
                    me.showMessage(title, content, buttons);
                }
            });
            copyButton.attr('id', 'copy-' + conf.type + '-' + conf.id);
            container.append(copyButton);
            return container;
        },

        _deleteGeometry: function (feature, geometryType) {
            var me = this;
            var okBtn = Oskari.clazz.create('Oskari.userinterface.component.Button');
            var cancelBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.CancelButton');
            var title = me.loc.deleteGeometryTitle;
            var content = me.loc.confirmDelete;

            okBtn.setTitle(me.instance.getLocalization('buttons').ok);
            okBtn.addClass('primary');
            okBtn.setHandler(function () {
                me._dialog.close(true);
                me._dialog = null;

                if (geometryType === 'point') {
                    feature._pointDeleted = true;
                } else if (geometryType === 'area') {
                    feature._areaDeleted = true;
                } else {
                    feature._deleted = true;
                }
                me._saveRegistryItem();
            });

            cancelBtn.setHandler(function () {
                me._dialog.close(true);
                me._dialog = null;
            });
            me.showMessage(title, content, [cancelBtn, okBtn], true);
        },

        _deleteFromMulti: function (feature, geometryType) {
            var me = this;
            var cancelBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.CancelButton');
            var title = me.loc.deleteFromMultiTitle;
            var content = me.loc.deleteFromMulti;

            cancelBtn.setHandler(function () {
                me.instance.listenMapClickEvents(false);
                me._dialog.close(true);
                me._dialog = null;
            });

            me.instance.enableGfi(false);
            me.instance.listenMapClickEvents(true, me._deleteMultiFromPoint);
            me.showMessage(title, content, [cancelBtn], false).moveTo('button#' + 'deleteFromMulti-' + feature._type + "-" + feature.id, 'bottom');
        },

        _deleteMultiFromPoint: function (event) {
            var me = this;
            var okBtn = Oskari.clazz.create('Oskari.userinterface.component.Button');
            var cancelBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.CancelButton');
            var title = me.loc.deleteFromMultiConfirmationTitle;
            var content = me.loc.deleteFromMultiConfirmation;
            var coords = {
                type: 'Point',
                coordinates: [
                    event.getLonLat().lon,
                    event.getLonLat().lat
                ]
            };
            var geom = me.editFeature.geometry;
            var olMultiPolygon = new olGeom.MultiPolygon(geom.coordinates);

            if (olMultiPolygon.intersectsCoordinate(coords.coordinates)) {
                okBtn.setTitle(me.instance.getLocalization('buttons').ok);
                okBtn.addClass('primary');
                okBtn.setHandler(function () {
                    me._dialog.close(true);
                    me._dialog = null;
                    var polygons = olMultiPolygon.getPolygons();
                    var coordinates = [];
                    for (var i = 0; i < polygons.length; i++) {
                        if (!polygons[i].intersectsCoordinate(coords.coordinates)) {
                            coordinates.push(polygons[i].getCoordinates());
                        }
                    }
                    var editedMultiPolygon = {
                        type: 'MultiPolygon',
                        coordinates
                    };
                    me.editFeature.geometry = editedMultiPolygon;
                    me.editFeature._edited = true;
                    me._saveRegistryItem();
                    me.instance.enableGfi(true);
                    me.instance.listenMapClickEvents(false);
                });

                cancelBtn.setHandler(function () {
                    me._dialog.close(true);
                    me._dialog = null;

                    me.instance.enableGfi(true);
                    me.instance.listenMapClickEvents(false);
                });

                me.showMessage(title, content, [cancelBtn, okBtn], false);
            }
        },

        /**
         * @method _getGeometryInfoForCopy
         * Checks if the feature has valid geometry type according to configuration object.
         * Returns object containing information about geometry type and GeoJSON string of the feature.
         */
        _getGeometryInfoForCopy: function (conf, feature) {
            var geoJsonForCopy = feature;
            var geometryType = null;
            var featureGeoJson = null;

            if (typeof conf.area !== 'undefined' && conf.area) {
                geometryType = 'area';
                featureGeoJson = geoJsonForCopy;
            } else if (typeof conf.point !== 'undefined' && conf.point) {
                geometryType = 'point';
                geoJsonForCopy.type = 'Point';
                geoJsonForCopy.coordinates = [geoJsonForCopy.coordinates[0][0], geoJsonForCopy.coordinates[0][1]];
                featureGeoJson = geoJsonForCopy;
            } else if (typeof conf.line !== 'undefined' && conf.line) {
                geometryType = 'line';
                featureGeoJson = geoJsonForCopy;
            }

            if (featureGeoJson != null) {
                return { 'geometryType': geometryType, 'featureGeoJson': featureGeoJson};
            } else {
                return null;
            }
        },

        _getLayerAttributes: function (layer, feature) {
            // Make copies of fields and locales
            var locales = (layer.getLocales && layer.getLocales()) ? layer.getLocales().slice(0) : [];
            var attributes = [];

            var fields = feature && feature.values_ ? Object.keys(feature.values_) : [];

            for (var i = 0; i < fields.length; i += 1) {
                // Get only the fields which originate from the service,
                // that is, exclude those which are added by Oskari (starts with '__').
                if (!fields[i].match(/^__/)) {
                    attributes.push({
                        id: fields[i],
                        name: (locales[i] || fields[i])
                    });
                }
            }
            return attributes;
        },

        _showDrawHelper: function (drawMode, id, isEdit) {
            if (this._dialog) {
                this._dialog.close(true);
                this._dialog = null;
            }
            var me = this;
            var locToolGeneral = this.instance.getLocalization('tools');
            var locTool = locToolGeneral[drawMode];
            var locBtns = this.instance.getLocalization('buttons');
            var title = locTool.title;
            var message = locTool.add;
            var dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
            this._dialog = dialog;

            if (isEdit) {
                message = locTool.edit;
            }
            var buttons = [];
            var cancelBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.CancelButton');
            cancelBtn.setHandler(function () {
                // ask toolbar to select default tool
                var toolbarRequest = Oskari.getSandbox().getRequestBuilder('Toolbar.SelectToolButtonRequest')();
                me.instance.sandbox.request(me, toolbarRequest);
                me.sendStopDrawRequest(true);
                dialog.close(true);
                me._dialog = null;
            });
            buttons.push(cancelBtn);
            var finishBtn = Oskari.clazz.create('Oskari.userinterface.component.Button');
            finishBtn.setTitle(locBtns.finish);
            finishBtn.addClass('primary');
            finishBtn.setHandler(function () {
                me.sendStopDrawRequest(false);
                console.log(me.geoJson.features);
                var geometry = me.geoJson.features[0].geometry;

                // multiple feature --> multipolygon
                if (me.geoJson.features.length > 1) {
                    geometry = {
                        type: 'MultiPolygon',
                        coordinates: []
                    };

                    for (var i = 0; i < me.geoJson.features.length; i++) {
                        geometry.coordinates.push(me.geoJson.features[i].geometry.coordinates);
                    }
                } else {
                    console.log(geometry);
                    if (geometry.type === 'Polygon' || geometry.type === 'MultiPolygon') {
                        /*if(!isEdit && me.geoJson.features.length === 1){
                            var singlePolygonArray = [];
                            singlePolygonArray.push(geometry.coordinates);
                            geometry.coordinates = singlePolygonArray;
                        }*/
                        if (me.geoJson.features.length > 1) {
                            var coordinatesArray = [];
                            const type = "MultiPolygon";

                            if (isEdit) {
                                for (var i = 0; i < me.geoJson.features.length; i++) {
                                    geometry.type = type;
                                    //TODO: add support for adding new polygon to multipolygon while editing
                                    coordinatesArray.push(me.geoJson.features[i].geometry.coordinates);
                                }

                                geometry.coordinates = coordinatesArray;
                            }
                        }
                    }
                }
                console.log(geometry);
                me._dialog.close(true);
                me._dialog = null;
                me._showParameterUpdateDialog(id, geometry);
            });
            buttons.push(finishBtn);

            //setContent
            var content = me.templates.drawHelper.clone();
            content.find('div.infoText').html(message);
            if (isEdit && (drawMode == 'area' || drawMode == 'line')) {
                var editMethodRadioGroup = Oskari.clazz.create('Oskari.userinterface.component.RadioButtonGroup');
                editMethodRadioGroup.setName('editMethod');
            }
            dialog.show(title, content, buttons);
            dialog.addClass('registryEditor');
            dialog.makeDraggable();
            dialog.moveTo('button#' + id, 'bottom');
        },

        /**
         * @method _showParameterUpdateDialog
         * Show a dialog to fill proper attributes of the feature
         * @param id DOM element id of the tool button
         * @param geometry new geometry in GeoJson format
         */
        _showParameterUpdateDialog: function (id, geometry, attributes, selectedFeature, fields, defaults) {
            var me = this,
                locBtns = me.instance.getLocalization('buttons'),
                dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup'),
                buttons = [],
                title = me.loc.geometryDetailsInfoTitle,
                cancelBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.CancelButton'),
                finishBtn = Oskari.clazz.create('Oskari.userinterface.component.Button'),
                editForm = me.registerView.renderUpdateDialogContent(attributes, selectedFeature, fields, defaults);

            //If edit form provided then show it and collect data for update. Otherwise save only geometry.
            if (editForm != null) {
                me._dialog = dialog,
                cancelBtn.setHandler(function () {
                    // ask toolbar to select default tool
                    var toolbarRequest = me.instance.sandbox.getRequestBuilder('Toolbar.SelectToolButtonRequest')();
                    me.instance.sandbox.request(me, toolbarRequest);
                    me.sendStopDrawRequest(true);
                    dialog.close(true);
                    me._dialog = null;
                });
                buttons.push(cancelBtn);

                finishBtn.setTitle(locBtns.finish);
                finishBtn.addClass('primary');
                finishBtn.setHandler(function () {
                    me.editFeature._edited = true;
                    me.registerView.collectDataForUpdate(content, geometry);
                    me.sendStopDrawRequest(true);
                    me._dialog.close(true);
                    me._dialog = null;
                    me._saveRegistryItem();
                });
                buttons.push(finishBtn);

                var content = me.templates.drawHelper.clone();
                content.find('div.infoText').html(me.loc.geometryDetailsInfo);
                content.append(editForm);
                dialog.show(title, content, buttons);
                dialog.moveTo('div#' + id, 'top');
            } else {
                me.sendStopDrawRequest(true);
                me.editFeature._edited = true;
                me.registerView.collectDataForUpdate(null, geometry);
                me._saveRegistryItem();
            }
        },

        _saveRegistryItem: function () {
            var me = this,
                postData = me.registerView.preparePostData();
            if (postData != null) {
                jQuery.ajax({
                    url: me.instance.sandbox.getAjaxUrl() + "action_route=UpdateRegistryItems",
                    data: postData,
                    type: 'POST',
                    success: function (data, textStatus, jqXHR) {
                        if (data.updated) {
                            me._refreshData(me.data.id);
                            var message = me.loc.featureUpdated;
                            if(data.areaIntersects) {
                                message = message + '<br/>' + me.loc.areaIntersects;
                            }
                            me.showMessage(me.loc.success, message);
                            me._clearTiles();
                        } else if (data.deleted) {
                            me._refreshData(me.data.id);
                            var message = me.loc.featureDeleted;
                            me.showMessage(me.loc.success, message);
                            me._clearTiles();
                        } else {
                            var errorMessage = me.loc.updateError;
                            if (typeof data.error !== 'undefined' && typeof me.loc[data.error] !== 'undefined') {
                                errorMessage = me.loc[data.error];
                            }
                            me.showMessage(me.loc.error, errorMessage);
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        me.showMessage(me.loc.error, me.loc.updateError);
                    }
                });
            } else {
                me.showMessage(me.loc.error, me.loc.updateError);
            }
        },

        _clearTiles: function() {
            var me = this;
            me.sandbox.findRegisteredModuleInstance('MainMapModule').getLayerPlugins('wfs').refreshLayersOfType('wfs');
        },

        addDropdownsToTemplate: function (template, attributes, selectedFeature, fields) {
            var me = this;
            //template.find("input[type=text]").each(function () {
            template.find("input").each(function () {
                var input = jQuery(this);
                var attrSelect = jQuery('<select></select>');
                me._appendOptionValues(attrSelect, me.loc.selectAttribute, attributes);
                attrSelect.on('change', function () {
                    var attrIndex = fields.indexOf(jQuery(this).val());
                    var attr = fields[attrIndex];
                    //var attrValue = selectedFeature.values_[attrIndex];
                    var attrValue = selectedFeature.values_[attr];
                    input.val(attrValue);
                });
                input.before(attrSelect);
            });
        },

        _appendOptionValues: function (select, placeHolder, values) {
            var option = jQuery("<option></option>"),
                i;
            // Append the first, empty value to work as a placeholder
            if (placeHolder) {
                option.attr('value', '');
                option.attr('disabled', 'disabled');
                option.attr('selected', 'selected');
                option.html(placeHolder);
                select.append(option);
            }

            // Iterate the list of given values
            for (i = 0; values && i < values.length; ++i) {
                option = jQuery("<option></option>");
                // Array of strings.
                if (typeof values[i] === 'string') {
                    option.attr('value', values[i]);
                    option.html(values[i]);
                } else {
                    // Otherwise we're assuming an array of objects.
                    option.attr('value', values[i].id);
                    option.html(values[i].name);
                }
                select.append(option);
            }
        },

        _showCoordinatesPopUp: function (elementId) {
            var me = this,
                popupContent = me.templates.coordinatePopupContent.clone(),
                title = me.loc.coordinatePopup.title,
                saveBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.SubmitButton'),
                cancelBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.CancelButton'),
                buttons = null,
                lon = null,
                lat = null,
                selectedProjection = null;

            me.closeDialog();
            me._dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
            popupContent.find('.description').html(me.loc.coordinatePopup.description);

            //TODO: Add projections array to app config. Example:
            var conf = {
                projections : [
                    {
                        "name": "EPSG:3067",
                        "text": "ETRS89-TM35FIN (EPSG:3067)",
                        "definition": "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs",
                        "default": true
                    },
                    {
                        "name": "EPSG:4326",
                        "text": "WGS84 (EPSG:4326)",
                        "definition": "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs",
                        "default": false
                    },
                    {
                        "name": "EPSG:2393",
                        "text": "YKJ (EPSG:2393)",
                        "definition": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +towgs84=-96.0617,-82.4278,-121.7535,4.80107,0.34543,-1.37646,1.4964 +units=m +no_defs",
                        "default": false
                    }
                ]
            };
            // Set the dropdown with supported projections
            if (conf && conf.projections && conf.projections.length > 0) {
                me._coordsConvertionEnabled = true;
                jQuery.each(conf.projections, function (i, item) {
                    popupContent.find('.srs-select').append(jQuery('<option>', {
                        value: item.name,
                        text: item.text
                    }));
                    if (item.default) {
                        popupContent.find('.srs-select option[value="' + item.name + '"]').prop("selected", "selected");
                    }
                    proj4.defs[item.name] = item.definition;
                });
            } else {
                me._coordsConvertionEnabled = false;
                popupContent.find('.srs-select').append(jQuery('<option>', {
                    value: crs,
                    text: crsText,
                    selected: "selected"
                }));
            }
            saveBtn.setTitle(me.loc.coordinatePopup.saveObject)
            saveBtn.setHandler(function () {
                lon = parseFloat(popupContent.find('.lon-input').val());
                lat = parseFloat(popupContent.find('.lat-input').val());
                selectedProjection = popupContent.find('.srs-select').val();

                if (lon != null && !isNaN(lon) && lat != null && !isNaN(lat)) {
                    me._dialog.close(true);
                    me._dialog = null;
                    me._addPointFromCoordinates(lon, lat, selectedProjection, elementId);
                } else {
                    me.showMessage(me.loc.error, me.loc.coordinatePopup.missingCoordsError);
                }
            });

            cancelBtn.setHandler(function () {
                me._dialog.close(true);
                me._dialog = null;
            });
            buttons = [cancelBtn, saveBtn];
            me._dialog.show(title, popupContent, buttons);
        },

        _addPointFromCoordinates: function (lon, lat, crs, elementId) {
            var me = this,
                convertedCoordinates,
                mapModule = me.sandbox.findRegisteredModuleInstance('MainMapModule'),
                currentProjection = mapModule.getProjection(),
                geometry = null;
            var bool = me._coordsConvertionEnabled;
            //Coordinates conversion does not work
            /*if (me._coordsConvertionEnabled) {
                convertedCoordinates = me._convertCoordinates(crs, currentProjection, coordinates);
            } else {
                convertedCoordinates = coordinates;
            }*/
            var newPoint = {
                    'type': 'Point',
                    'coordinates': [lon, lat]
            };
            geometry = newPoint;
            me._showParameterUpdateDialog(elementId, geometry);
        },

        /**
         * Converts coordinates from one projection to another
         * @method @private _convertCoordinates
         * @param {string} sourceSrs source projection
         * @param {string} destSrs destination projection
         * @param {Object} coordinates lon and lat object {lonlat: { lat: 0, lon: 0}}
         * @return {Object} converted coordinates lon and lat object {lonlat: { lat: 0, lon: 0}}
         */
        _convertCoordinates: function (sourceSrsName, destSrsName, coordinates) {
            var me = this,
                source,
                dest,
                point,
                convertedCoords;
            if (me._coordsConvertionEnabled) {
                // conversion from (long/lat) to UTM (E/N)const en_m =
                // proj4("EPSG:4326", "EPSG:AUTO", [lon_input, lat_input]);
                /*point = new proj4.point(coordinates.lonlat.lon, coordinates.lonlat.lat),
                convertedCoords = proj4.transform(source, dest, point);*/
                if(destSrsName !== sourceSrsName) {
                    convertedCoords = proj4(sourceSrsName, destSrsName, [coordinates.lonlat.lon, coordinates.lonlat.lat]);
                };
                return {
                    'lonlat': {
                        'lon': convertedCoords.x,
                        'lat': convertedCoords.y
                    }
                };
            } else {
                return coordinates;
            }
        },

        /**
         * @method destroy
         * Destroys/removes this view from the screen.
         *
         *
         */
        destroy: function () {
            //reset tools
            this.sendStopDrawRequest(true);
            this.mainPanel.remove();
        }
    }, {
        /**
         * @property {String[]} protocol
         * @static
         */
        protocol: ['Oskari.mapframework.module.Module']
    });
